// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import Image from 'church-theme-library/components/Image/Image'

class Quote extends React.Component {
	render() {
		const { contentId, sectionId, data, userCanEditPage } = this.props

		if ( ! data ) {
			return null
		}

		const fullData = {
			image: data.image || {
				thumb: '',
				url: '',
				srcset: '',
				alt: '',
				width: '',
				height: '',
				focal_point: '',
				aspect_ratio: ''
			},
			content: data.content || '',
			cite_name: data.cite_name || '',
			cite_title: data.cite_title || ''
		}

		return (
			<div className="section-quote">
				<div className="-inner">
					<div className="-image-wrap">
						<div className="editor-image-placeholder"></div>

						<Editable
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="image"
							className="-image"
						>
							<Image
								thumb={ fullData.image.thumb }
								thumbWebp={ fullData.image.thumb_webp }
								url={ fullData.image.url }
								srcset={ fullData.image.srcset }
								srcsetWebp={ fullData.image.srcset_webp }
								sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 400px` }
								alt={ fullData.image.alt }
								width={ fullData.image.width }
								height={ fullData.image.height }
								focalPoint={ fullData.image.focal_point }
								aspectRatio={ fullData.image.aspect_ratio }
							/>
						</Editable>
					</div>

					<div className="-content">
						<div className="-text">
							<Editable
								id={ contentId }
								sectionId={ sectionId }
								sectionType={ data.type }
								sectionDataId="content"
								content={ fullData.content }
							/>
						</div>

						{ ( userCanEditPage || fullData.cite_name || fullData.cite_title ) &&
							<p className="-cite">
								<Editable
									element="span"
									className="-cite-name"
									id={ contentId }
									sectionId={ sectionId }
									sectionType={ data.type }
									sectionDataId="cite_name"
									content={ fullData.cite_name }
								/>

								<Editable
									element="span"
									className="-cite-title"
									id={ contentId }
									sectionId={ sectionId }
									sectionType={ data.type }
									sectionDataId="cite_title"
									content={ fullData.cite_title }
								/>
							</p>
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let userCanEditPage = siteData.current_user_can_edit_pages

	if ( state.page.selected && state.page.selected.is_external ) {
		userCanEditPage = false
	}

	return {
		userCanEditPage
	}
}

export default connect( mapStateToProps )( Quote )
